import api from './api';

export const backupApi = {
  // Crear backup
  createBackup: () => api.post('/backup/create'),
  
  // Listar backups
  listBackups: () => api.get('/backup/list'),
  
  // Descargar backup
  downloadBackup: (filename) => api.get(`/backup/download/${filename}`, {
    responseType: 'blob'
  }),
  
  // Eliminar backup
  deleteBackup: (filename) => api.delete(`/backup/${filename}`),
  
  // Restaurar backup
  restoreBackup: (filename) => api.post(`/backup/restore/${filename}`),
  
  // Subir backup
  uploadBackup: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/backup/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};
